;(function($) {

	$(document).ready(function() {

		// ---------- Ajax Add to Cart ----------

		if(typeof ajax_add_to_cart_params !== 'undefined') {

			var add_to_cart_text = JSON.parse(ajax_add_to_cart_params.localized_text);

			//Add to cart on single page
			$(document).on('submit', 'form.cart', function(e) {
				e.preventDefault();

				var add_to_cart_btn = $(this).find('.single_add_to_cart_button');

				if(add_to_cart_btn.find('.add-to-cart-icon').length !== 0) {
					add_to_cart_btn.find('.add-to-cart-icon').html('<i class="ion-load-c fa-spin"></i>');
				}
				else {
					add_to_cart_btn.append('<span class="add-to-cart-icon"><i class="ion-load-c fa-spin"></i></span>');
				}

				if(add_to_cart_btn.length === 0) {
					var add_to_cart_btn = $(this).find('button');
				}

				var product_id = parseInt($(this).find('[name=add-to-cart]').val());
				var quantity = parseInt($(this).find('.quantity').find('.qty').val());

				ajax_add_to_cart(product_id, quantity, add_to_cart_btn);//Ajax add to cart
			});

		}

		//Add to cart ajax function
		function ajax_add_to_cart(product_id, quantity, add_to_cart_btn) {

			$.ajax({
				url:      ajax_add_to_cart_params.admin_url,
				type:     'POST',
				dataType: 'json',
				data:     {
					action:     ajax_add_to_cart_params.action,
					nonce:      ajax_add_to_cart_params.nonce,
					product_id: product_id,
					quantity:   quantity
				},
				success:  function(response, status, jqXHR) {
					add_to_cart_btn.find('.add-to-cart-icon').html('<i class="ion-ios-checkmark-outline" aria-hidden="true"></i>');
					var navbar_cart = $('.cart-icon');

					navbar_cart.find('span').text(response.data.cart_count);

					bootbox.dialog({
						backdrop:    true,
						closeButton: false,
						className:   'add-to-cart-modal',
						message:     '<div>' + add_to_cart_text.added + '</div>' +
						             '<div><a href="' + ajax_add_to_cart_params.cart_url + '" class="btn btn-primary btn-gradient btn-lg"><span>' + add_to_cart_text.checkout + '</span></a></div>',
						buttons:     {
							dismiss: {
								label:     add_to_cart_text.continue,
								className: "btn-link",
								callback:  function() {
									add_to_cart_btn.find('.add-to-cart-icon').fadeOut(500, function() {
										$(this).remove();
									});
									$(this).modal('hide');
								}
							}
						}
					});
				}
			});
		}

	});

}(jQuery));

;(function($) {

	$(document).ready(function() {

		// ---------- Ajax Posts ----------

		var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
		var lazyLoadRefreshEvent = 'lazyload.refresh';
		var ajax_posts_form = $('form#ajax-posts-form');

		if(ajax_posts_form.length && typeof ajax_posts_params !== 'undefined') {

			var ajax_posts_button = ajax_posts_form.find('button[type=submit]');
			var ajax_posts_filters = ajax_posts_form.find('.ajax-posts-filter');
			var ajax_posts_content = ajax_posts_form.find('#ajax-posts');

			ajax_posts_button.on('click', function() {
				ajax_posts_form.data('append', true);
				$(this).addClass('loading');
			});

			ajax_posts_filters.on('change', function() {
				ajax_posts_form.data('append', false);
				ajax_posts_form.find('input[name=page]').val(1);
				ajax_posts_form.submit();
				$(this).parent().addClass('loading');
			});

			ajax_posts_form.on('submit', function(e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				ajax_posts_button.attr('disabled', true);

				var data = ajax_posts_form.serializeArray().reduce(function(obj, item) {
					if(obj[item.name]) {
						if(obj[item.name] instanceof Array) {
							obj[item.name].push(item.value);
						}
						else {
							obj[item.name] = [obj[item.name], item.value];
						}
					}
					else {
						obj[item.name] = item.value;
					}
					return obj;
				}, {});

				data['action'] = ajax_posts_params.action;
				data['nonce'] = ajax_posts_params.nonce;

				$.ajax({
					url:      ajax_posts_params.admin_url,
					type:     'POST',
					dataType: 'json',
					data:     data,
					success:  function(response, status, jqXHR) {

						ajax_posts_button.attr('disabled', false);

						ajax_posts_filters.parent().addClass('loaded').on(transitionEndEvent, function() {
							var self = $(this);

							self.off(transitionEndEvent);
							self.removeClass('loading loaded');
						});

						ajax_posts_button.addClass('loaded').on(transitionEndEvent, function() {
							var self = $(this);

							self.off(transitionEndEvent);
							self.removeClass('loading loaded');
						});

						if(response.success) {

							if(response.data.content) {

								if(ajax_posts_form.data('append') !== true) {
									ajax_posts_content.empty();
								}

								ajax_posts_content.append($(response.data.content));
								$(window).trigger(lazyLoadRefreshEvent);
							}

							if(response.data.next_page === 0) {
								ajax_posts_button.addClass('d-none');
								ajax_posts_button.attr('disabled', true);
							}
							else {
								ajax_posts_form.find('input[name=page]').val(response.data.next_page);
								ajax_posts_button.removeClass('d-none');
							}

						}
						else {
							console.error(response.data.error);
						}
					}
				});

				return false;
			});
		}
	});

}(jQuery));

;(function($) {

	var animationEndEvent = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';
	var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
	var lazyLoadRefreshEvent = 'lazyload.refresh';
	var mobileBreakpoint = 1024;
	var scrollController = new ScrollMagic.Controller();

	function handleResize(mobile, desktop) {

		$(window).debounce('resize', function() {

			if(typeof mobile === 'function' && window.innerWidth < mobileBreakpoint && scrollController.enabled()) {
				mobile();
			}
			else if(typeof desktop === 'function' && window.innerWidth >= mobileBreakpoint && !scrollController.enabled()) {
				desktop();
			}

		}, 200);
	}

	$(document).ready(function() {

		//======================================
		//	!---------- ANIMATIONS ----------
		//======================================

		// ---------- Global ----------

		$('.animated-section').each(function() {

			var self = $(this);

			var sectionScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: 0.6, reverse: false })
				.setClassToggle(this, 'active')
				.addTo(scrollController);

			handleResize(function() {
				sectionScene.progress(1);
			});

		});

		// ---------- Parallax ----------

		$('.parallax-section:not(.fixed-parallax-section)').each(function() {

			if(!$('html').hasClass('safari') || !$('html').hasClass('internet-explorer')) {
				var self = $(this);
				var image = self.find('.parallax-image');
				var speed = 50;
				var tween = new TimelineMax()
					.fromTo(image, 1, { y: '-' + speed + '%', ease: Linear.easeNone }, { y: speed + '%', ease: Linear.easeNone })

				var parallaxScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: "onEnter", duration: "200%" })
					.setTween(tween)
					.addTo(scrollController);

				handleResize(function() {
					parallaxScene.progress(0.5);
				});
			}

		});

		// ---------- Controller ----------

		handleResize(function() {
			scrollController.enabled(false);
		}, function() {
			scrollController.enabled(true).update(true);
		});

		$(window).trigger('resize');
	});

}(jQuery));

;(function($) {

	$(document).ready(function() {

		// ---------- Downloads ----------

		var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
		var downloads_form = $('form#downloads-form');

		if(downloads_form.length && typeof downloads_params !== 'undefined') {

			var downloads_button = downloads_form.find('button[type=submit]');
			var select_button = downloads_form.find('button.select-all');
			var checkboxes = downloads_form.find('input[type=checkbox]');

			select_button.text(select_button.data('select-label'));

			select_button.on('click', function() {
				var deselect_class = 'deselect-all';

				if(select_button.hasClass(deselect_class)) {
					select_button.removeClass(deselect_class);
					select_button.text(select_button.data('select-label'));
					checkboxes.attr('checked', false);
				}
				else {
					select_button.addClass(deselect_class);
					select_button.text(select_button.data('deselect-label'));
					checkboxes.attr('checked', true);
				}

				checkboxes.trigger('change');
			});

			checkboxes.on('change', function() {
				var checked = downloads_form.find(':checked').length;

				downloads_button.find('span').text(checked);
				downloads_button.attr('disabled', !(checked > 0));
			});

			downloads_button.on('click', function() {
				$(this).addClass('loading');
			});

			downloads_form.on('submit', function(e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				downloads_button.attr('disabled', true);

				var data = downloads_form.serializeArray().reduce(function(obj, item) {
					if(obj[item.name]) {
						if(obj[item.name] instanceof Array) {
							obj[item.name].push(item.value);
						}
						else {
							obj[item.name] = [obj[item.name], item.value];
						}
					}
					else {
						obj[item.name] = item.value;
					}
					return obj;
				}, {});

				data['action'] = downloads_params.action;
				data['nonce'] = downloads_params.nonce;

				$.ajax({
					url:      downloads_params.admin_url,
					type:     'POST',
					dataType: 'json',
					data:     data,
					success:  function(response, status, jqXHR) {

						downloads_button.attr('disabled', false);

						downloads_button.addClass('loaded').on(transitionEndEvent, function() {
							var self = $(this);

							self.off(transitionEndEvent);
							self.removeClass('loading loaded');
						});

						if(response.success) {
							window.location = response.data.file_url;
						}
						else {
							console.error(response.data.error);
						}
					}
				});

				return false;
			});
		}
	});

}(jQuery));

;(function($) {

	$(document).ready(function() {

		// ---------- Newsletter ----------

		var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
		var newsletter_form = $('form#newsletter-form');

		if(newsletter_form.length && typeof newsletter_params !== 'undefined') {

			var newsletter_button = newsletter_form.find('button[type=submit]');

			newsletter_button.on('click', function() {
				newsletter_form.find('input[type=email]').removeClass('is-invalid');
				$(this).addClass('loading');
			});

			newsletter_form.on('submit', function(e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				newsletter_button.attr('disabled', true);

				var data = newsletter_form.serializeArray().reduce(function(obj, item) {
					if(obj[item.name]) {
						if(obj[item.name] instanceof Array) {
							obj[item.name].push(item.value);
						}
						else {
							obj[item.name] = [obj[item.name], item.value];
						}
					}
					else {
						obj[item.name] = item.value;
					}
					return obj;
				}, {});

				data['action'] = newsletter_params.action;
				data['nonce'] = newsletter_params.nonce;

				$.ajax({
					url:      newsletter_params.admin_url,
					type:     'POST',
					dataType: 'json',
					data:     data,
					success:  function(response, status, jqXHR) {

						newsletter_button.attr('disabled', false);

						newsletter_button.addClass('loaded').on(transitionEndEvent, function() {
							var self = $(this);

							self.off(transitionEndEvent);
							self.removeClass('loading loaded');
						});

						if(response.success) {
							newsletter_form.empty();
							newsletter_form.append('<div class="success-message">' + response.data.message + '</div>')
						}
						else {
							newsletter_form.find('.invalid-tooltip').text(response.data.error);
							newsletter_form.find('input[type=email]').addClass('is-invalid');
						}
					}
				});

				return false;
			});
		}
	});

}(jQuery));

;(function($) {

	var animationEndEvent = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';
	var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
	var lazyLoadRefreshEvent = 'lazyload.refresh';
	var mobileBreakpoint = 1024;

	$(document).ready(function() {

		// ---------- Sections ----------

		$('.fixed-image').each(function() {
			var self = $(this);

			var factor = (self.hasClass('contact-page')) ? 1.15 : 1.3;

			self.find('.columns-section-content .content .content-inner').each(function() {
				var content = $(this);

				content.fitText(factor);
			});
		});

	});

}(jQuery));

;(function($) {

	var animationEndEvent = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';
	var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
	var lazyLoadRefreshEvent = 'lazyload.refresh';
	var mobileBreakpoint = 1024;

	window.lazySizesConfig.throttleDelay = 66;
	window.lazySizesConfig.preloadAfterLoad = true;

	$(document).ready(function() {

		//==================================
		//	!---------- GLOBAL ----------
		//==================================

		var body = $('body');

		// ---------- Replace hover rules by active on touchscreens ----------

		if(!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
			for(var sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
				var sheet = document.styleSheets[sheetI];
				if(sheet.cssRules) {
					for(var ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
						var rule = sheet.cssRules[ruleI];

						if(rule.selectorText) {
							rule.selectorText = rule.selectorText.replace(':hover', ':active');
						}
					}
				}
			}
		}

		// ---------- Menu ----------

		$('.mobile-menu-toggle').click(function(e) {
			e.preventDefault();

			var menu = document.getElementById("mobile-menu-wrapper");

			if(body.hasClass('mobile-menu-open')) {
				body.removeClass('mobile-menu-open');
				bodyScrollLock.enableBodyScroll(menu);
			}
			else {
				body.addClass('mobile-menu-open');
				bodyScrollLock.disableBodyScroll(menu);
			}
		});

		$('.mobile-menu-overlay').click(function(e) {
			e.preventDefault();

			$('.mobile-menu-toggle').trigger('click');
		});

		$('.navbar-menu a, .mobile-menu-wrapper a').click(function(e) {

			var self = $(this);
			var link_target = self.attr('href');
			var section_target = link_target.substring(link_target.lastIndexOf('#'), link_target.length);

			if(body.hasClass('home') && section_target.substring(0, 1) === '#') {

				e.preventDefault();

				body.removeClass('mobile-menu-open');

				if($(section_target).length) {
					$('html, body').stop().animate({
						scrollTop: $(section_target).offset().top - 70
					}, 1000);
				}
			}
		});

		// ---------- Links ----------

		$('a[href="#"], .void-link').click(function(e) {
			e.preventDefault();
		});

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			var self = $(this);
			var target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {
				var offset = (target.offset().top > 320) ? target.offset().top : 0;
				$('html, body').stop().animate({
					scrollTop: offset
				}, 1000);
			}
		});

		// ---------- Animsition ----------

		$('.main-wrapper').animsition({
			inClass:     'fade-in',
			outClass:    'fade-out',
			inDuration:  600,
			outDuration: 400,
			linkElement: 'a:not([target="_blank"]):not([href^="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([data-lity]):not([href=""])',
		});

		// ---------- Carousels ----------

		$('.content-section .masonry').each(function() {
			var self = $(this);

			self.isotope({
				masonry:      {
					percentPosition: true
				},
				itemSelector: ".single-column"
			})
		});

		$('.content-section .carousel').each(function() {

			var self = $(this);

			var settings = {
				arrows:         false,
				infinite:       false,
				centerMode:     false,
				slidesToShow:   4,
				slidesToScroll: 4,
				responsive:     [
					{
						breakpoint: 1024,
						settings:   {
							slidesToShow:   3,
							slidesToScroll: 3
						}
					},
					{
						breakpoint: 768,
						settings:   {
							slidesToShow:   2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 480,
						settings:   {
							slidesToShow:   1,
							slidesToScroll: 1
						}
					}
				]
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(lazyLoadRefreshEvent);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.content-section .slideshow').each(function() {

			var self = $(this);

			var settings = {
				infinite:      true,
				autoplaySpeed: 3000,
				arrows:        false,
				autoplay:      true,
				speed:         2000,
				fade:          true,
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(lazyLoadRefreshEvent);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.gallery').each(function() {
			var self = $(this);

			self.lightGallery({
				download: false,
			});
		});

		// ---------- LazyLoad ----------

		$(window).on(lazyLoadRefreshEvent, function() {

			window.lazySizes.loader.checkElems();
			window.lazySizes.autoSizer.checkElems();

		});

		$(window).trigger(lazyLoadRefreshEvent);

		// ---------- Vide ----------

		$(window).on('load', function() {

			$('.content-section .video-background').each(function() {
				var self = $(this);
				var video = self.data('video');
				var poster = self.data('poster');

				self.vide({
					mp4:    video,
					poster: poster
				}, {
					posterType: 'jpg'
				});
			});
		});

		// ---------- Disclaimer ----------

		$('.close-disclaimer').click(function(e) {
			e.preventDefault();

			Cookies.set('tc-disclaimer', true, {
				expires: 365,
				path:    '/',
			});

			$('#disclaimer').fadeOut(1000, function() {
				$(this).remove();
			});

			body.removeClass('disclaimer-open');
		});

		$('#cookies-law').on('closed.bs.alert', function() {

			Cookies.set('tc-cookies', true, {
				expires: 365,
				path:    '/',
			});

		});

	});

}(jQuery));
